import { useMemo } from 'react';

import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import type { Channel } from './types';
import { useGetShareContent } from './useGetShareContent';
import { useGetShareTrackingData } from './useGetShareTrackingData';
import { useGetShareUrl } from './useGetShareUrl';

export function useShareOptions({ disableShortLinks }: { disableShortLinks: boolean }): ShareActionsOptions<Channel> {
	const getUrl = useGetShareUrl();
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();

	return useMemo(
		() => ({
			disableShortLinks,
			trackingEventName: 'share_dm_response',
			getUrl,
			getContent,
			getTrackingData,
		}),
		[getUrl, getContent, getTrackingData, disableShortLinks],
	);
}
